import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <path d="M40 12H24L20 8H8C5.8 8 4 9.8 4 12V36C4 38.2 5.8 40 8 40H40C42.2 40 44 38.2 44 36V16C44 13.8 42.2 12 40 12ZM36 24H32V28H36V32H32V36H28V32H32V28H28V24H32V20H28V16H32V20H36V24Z" />,
  'zip'
);
